import { render } from "./ConfigChanges.vue?vue&type=template&id=0d19fef6&scoped=true"
import script from "./ConfigChanges.vue?vue&type=script&lang=js"
export * from "./ConfigChanges.vue?vue&type=script&lang=js"

import "./ConfigChanges.vue?vue&type=style&index=0&id=0d19fef6&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d19fef6"]])

export default __exports__